import DataLayer from "./DataLayer";

export default (data) => {
    DataLayer.track({
        event: "checkout_option_payment",
        ecommerce: {
            checkout: {
                actionField: { step: 1, option: data.option },
            },
        },
    });
};
